import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../../../@vex/layout/layout.module';
import { SidenavModule } from '../../../@vex/layout/sidenav/sidenav.module';
import { ToolbarModule } from '../../../@vex/layout/toolbar/toolbar.module';
import { FooterModule } from '../../../@vex/layout/footer/footer.module';
import { ConfigPanelModule } from '../../../@vex/components/config-panel/config-panel.module';
import { SidebarModule } from '../../../@vex/components/sidebar/sidebar.module';
import { QuickpanelModule } from '../../../@vex/layout/quickpanel/quickpanel.module';
import { NOCLayoutComponent } from './noc-layout.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [NOCLayoutComponent],
  imports: [
    CommonModule,
    LayoutModule,
    SidenavModule,
    ToolbarModule,
    FooterModule,
    ConfigPanelModule,
    SidebarModule,
    QuickpanelModule,
    MatSnackBarModule,
    MatDialogModule
  ]
})
export class NOCLayoutModule {
}
